import React, {useState, useContext, useEffect} from 'react';
import { IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonHeader, IonContent, IonFooter, IonItem } from '@ionic/react';

import '../../css/layout.css';
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';



export function ShowProductPicsModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [accessRights, setAccessRights ] = useState(authenticatedMerchent_context.accessRights);

    let [showPasswordModal, setShowPasswordModal] = useState(false); 

    let [productImageNumber, setProductImageNumber] = useState(null);

    let [takePhotoStatus1, setTakePhotoStatus1] = useState(false);
    let [takePhotoStatus2, setTakePhotoStatus2] = useState(false);
    let [takePhotoStatus3, setTakePhotoStatus3] = useState(false);
    let [takePhotoStatus4, setTakePhotoStatus4] = useState(false);

    let [selectedFile, setSelectedFile] = useState(null);



    function selectedFileHandler1(event)
    {
        setProductImageNumber("1");
        setSelectedFile(event);
        setTakePhotoStatus1(false);
    }

    function selectedFileHandler2(event)
    {
        setProductImageNumber("2");
        setSelectedFile(event);
        setTakePhotoStatus2(false);
    }
    function selectedFileHandler3(event)
    {
        setProductImageNumber("3");
        setSelectedFile(event);
        setTakePhotoStatus3(false);
    }
    function selectedFileHandler4(event)
    {
        setProductImageNumber("4");
        setSelectedFile(event);
        setTakePhotoStatus4(false);
    }

    function handleFileChange(event) {

        //alert("in HadndleFileChange");
        //alert(event.target.dataset.id);
        // alert(event.target);
        // alert(event.target.files);
        // alert(event.target.files[0]);

        const file = event.target.files ? event.target.files[0] : null;
        setProductImageNumber(event.target.dataset.id);
        setSelectedFile(file);
    }

    function handleEnterAttachement(event) {  

        fetch(baseURL+'fileServer/merchants/attachment-not-available.png')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setProductImageNumber(event[0]);
            setSelectedFile(noImageFile);

            alert("No Photo Option checked");
        })
    }



    function uploadProductImage()
    {
    
        let formData = new FormData();
        formData.append('Tracker', '74300_Pic_retail');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xInventoryProductID', props.data.productID);
        formData.append('xProductImageNumber', productImageNumber);
        formData.append('xImageFile', selectedFile);
        formData.append('xEnterAdminPassword', accessRights[0]);
        formData.append('sessionID', sessionID);
    
        const requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
    
            // body: JSON.stringify({
            //     Tracker: '74300_Pic',
            //     user: acctID,
            //     xInventoryProductID: props.data.productID,
            //     xProductImageNumber: productImageNumber,
            //     xImageFile: selectedFile,
            //     xEnterAdminPassword: enteredPassword,
            //     sessionID: sessionID,
            // }),
        }
    
        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {
    
            alert(data);
    
            props.closeModal(false);
    
        })
        .catch(error => {
            console.error(error);
        })
    }
    
    function closeModalHandler() {
    
        props.closeModal(false);
    }
    
    //alert('Inside ShowProductPicsModal');
    //alert(props.data.productPic1);
    //alert(props.data.productPic2);
    //alert(props.data.productPic3);
    //alert(props.data.productPic4);
    
    return (
        <React.Fragment>
        {props.openModal == true ?
            (
        <IonModal id='showProductPics' isOpen={ props.openModal }>
        <IonHeader className='appModalHeader'>
            <IonGrid class='gridModalTopInfo'>
                        <IonRow>
                            <IonCol> Product ID</IonCol>
                            <IonCol> Price Per Night</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol> {props.data.productID} </IonCol>
                            <IonCol> {props.data.productSalePrice} </IonCol>
                        </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>
            <IonSlides pager='true' options={{direction: 'horizontal'}}>
            { props.data.productPic1 != 'null' &&  <IonSlide>
                    <IonGrid  >
                        <IonRow>
                            <IonCol> 1/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                               <IonImg src={`/api/image/${props.data.productPic1}/${props.data.companySchema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>}
                { props.data.productPic2 != 'null' && <IonSlide>
                    <IonGrid  >
                        <IonRow>
                            <IonCol> 2/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.productPic2}/${props.data.companySchema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>}
                { props.data.productPic3 != 'null' &&  <IonSlide>
                    <IonGrid  >
                        <IonRow>
                            <IonCol> 3/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.productPic3}/${props.data.companySchem}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>}
                { props.data.productPic4 != 'null' &&  <IonSlide>
                    <IonGrid  >
                        <IonRow>
                            <IonCol> 4/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.productPic4}/${props.data.companySchem}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>}
            </IonSlides>
        </IonContent>
    
        <IonFooter class='appFooter'>
    
            <IonButton onClick={closeModalHandler}> Close </IonButton>
    
        </IonFooter>
    
        {/*<EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>   */}                     
    
        </IonModal>) : null }
        </React.Fragment>
    )
}